export const LEAD = "lead"
export const CONFIRMED = "confirmed"
export const VALIDATED = "validated"
export const REFUSED = "refused"
export const CANCELED = "canceled"
